module.exports = __webpack_public_path__ + "static/img/10.0acd913.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/10.png
// module id = QNjZ
// module chunks = 0